import axios from "axios";

export const getLoadAgedInfo= (params) =>{
    return axios({
        method:'GET',
        url:'/system-ya/aged/info/'+params
    })
}

export const getHandleFamily= (params) =>{
    return axios({
        method:'GET',
        url:'/system-ya/gateway/getInfoByFamily/'+params
    })
}

export const getShowActivity= (params) =>{
    return axios({
        method:'GET',
        url:'/system-ya/wo/activities/'+params
    })
}

export const getLoadHealthInfo= (params) =>{
    return axios({
        method:'GET',
        url:'/system-ya/healthCheck/info/'+params
    })
}

export const postLoadDeviceTable= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/device/table",
        data:params
    })
}

export const postLoadLogTable= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/report/infrared/list",
        data:params
    })
}

export const postHandleUpdBed= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/"+"aged/updBed",
        data:params
    })
}

//保存图片-加载
export const getHandleAgedFileSuccess= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/aged/file/add",
        data:params
    })
}

//删除图片
export const getRemoveFile1= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/aged/file/remove",
        data:params
    })
}

export const postLoadCallRecordData= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/"+"seat/call/table",
        data:params
    })
}

export const postLoadWoTable= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/wo/table",
        data:params
    })
}

export const loadTableByAgedId= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/wo/tableByAgedId",
        data:params
    })
}

export const postLoadAgedFiles= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/"+"aged/"+params+"/files",
        data:params
    })
}

export const postLoadchangjinFiles= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/"+"aged/"+params+"/changjinFiles",
        data:params
    })
}

export const postHandleUpdate= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/aged/upd",
        data:params
    })
}

export const postLoadHealthCheckTable= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/healthCheck/table",
        data:params
    })
}

export const postLoadHealthTable= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/healthCheck/healthTable",
        data:params
    })
}

export const postLoadAgedLogs= (params) => {
    return axios({
        method:'post',
        url: "/system-ya/"+"aged/"+params+"/logs",

    })
}

export function getLoadAgedTypes(){
    return axios({
        method:'POST',
        url:'/system-ya/aged/type/list',
    })
}

export function getLoadAgedStandards(){
    return axios({
        method:'POST',
        url:'/system-ya/aged/standard/list',
    })
}

export function getLoadFamilies(){
    return axios({
        method:'get',
        url:'/system-ya/family/list',
    })
}

export function getGetRoomBed(){
    return axios({
        method:'get',
        url:'/system-ya/conRoomBed/tree',
    })
}
